import React from "react";
import { FaTwitter, FaFacebook, FaLinkedin, FaShareAlt, FaInstagram } from "react-icons/fa";
import { toast } from "react-toastify";

const ShareComponent = ({ url, text, title }) => {
  const handleWebShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: text,
          url: url,
        })
        .catch((err) => console.error("Error sharing:", err));
    } else {
      toast.info("Sharing not supported on this browser.");
    }
  };

  const handleFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`;
    window.open(facebookUrl, "_blank", "noopener,noreferrer");
  };

  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(text)}`;
    window.open(twitterUrl, "_blank", "noopener,noreferrer");
  };

  const handleLinkedinShare = () => {
    const linkedinUrl = `https://www.linkedin.com/company/wise-semicon/?url=${encodeURIComponent(
      url
    )}`;
    window.open(linkedinUrl, "_blank", "noopener,noreferrer");
  };

  const handleInstagramShare = () => {
    const instagramUrl = `https://www.instagram.com/wise_semicon/`;
    window.open(instagramUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="d-flex mt-4 mb-4" style={{ gap: "30px" }}>
      {/* Share (Gray) 
      <button
        onClick={handleWebShare}
        className="btn p-0"
        style={{ color: "gray" }}
        aria-label="Share via Web Share API"
      >
        <FaShareAlt size={30} />
      </button>
      */}

      {/* LinkedIn (Primary) */}
      <button
        onClick={handleLinkedinShare}
        className="btn p-0 text-primary"
        aria-label="Share on LinkedIn"
      >
        <FaLinkedin size={35} />
      </button>

    {/* Instagram (Primary) */}
      <button
        onClick={handleInstagramShare}
        className="btn p-0 text-danger"
        aria-label="Visit Instagram Page"
      >
        <FaInstagram size={35} />
      </button>


    {/* Facebook (Primary) 
      <button
        onClick={handleFacebookShare}
        className="btn p-0 text-primary"
        aria-label="Share on Facebook"
      >
        <FaFacebook size={35} />
      </button>

       Twitter (Primary) 
      <button
        onClick={handleTwitterShare}
        className="btn p-0 text-primary"
        aria-label="Share on Twitter"
      >
        <FaTwitter size={35} />
      </button>
      */}
    </div>
  );
};

export default ShareComponent;
